var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTraditionalFollower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 47,
    viewBox: "0 0 48 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0 1.00719V23.7222C0 36.5786 10.4331 47 23.2907 47C23.6286 47 23.9547 46.9941 24.2866 46.9763C24.3044 46.6504 24.3103 46.3187 24.3103 45.9928V23.2778C24.3103 10.4214 13.8832 0 1.0196 0C0.681709 0 0.355674 0.00592462 0.0237116 0.0236985C0.00592788 0.349553 0 0.681331 0 1.00719Z",
    fill: "#86AA57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M25.9307 39.1877V47C38.0345 46.0024 47.5399 35.8464 47.5399 23.4729V15.6666C41.815 16.1294 36.6663 18.6593 32.8377 22.4874C28.5711 26.7661 25.9367 32.6734 25.9367 39.1877H25.9307Z",
    fill: "#6A7C43"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTraditionalFollower);
export default __webpack_public_path__ + "static/media/traditional-follower.ad3d66915ed121532937f944c44894e2.svg";
export { ForwardRef as ReactComponent };